import React from 'react';

type Props = {
  color?: string;
  width?: number;
  height?: number;
};

export const AnalyticsIcon: React.FC<Props> = ({
  color = '#606C77',
  width = 24,
  height = 24,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Chart">
      <path
        id="Vector"
        d="M8.4 16.5V13.8M12 16.5V7.5M15.6 16.5V10.2M8 21H16C18.7614 21 21 18.7614 21 16V8C21 5.23858 18.7614 3 16 3H8C5.23858 3 3 5.23858 3 8V16C3 18.7614 5.23858 21 8 21Z"
        stroke={color}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
